import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  isZhCn = true;
  isEnUs = false;

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    // console.log(this.translate.getBrowserLang());
    this.translate.use('zh-cn');
    this.isZhCn = true;
    this.isEnUs = false;
  }

  useLanguage(lang) {
    this.translate.use(lang);
    if (lang === 'en-us') {
      this.isZhCn = false;
      this.isEnUs = true;
    }
    if (lang === 'zh-cn') {
      this.isZhCn = true;
      this.isEnUs = false;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/navbar/navbar.component.ts